// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"422":"671b309a","590":"350a5628","702":"f99c0d67"}[chunkId] + ".chunk.js";
};